import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AnswersWrapper from './AnswersWrapper';
import SubmitButton from '../SubmitButton';
import QuestionPrompt from '../QuestionPrompt';

export default function Question({ question }) {
  const { displaySamePage } = question;
  const questionIndex = Pollfish.helper.getQuestionIndex();

  const renderQuestions = displaySamePage ? question.questions : [question];

  const submitBtnProps = {
    onTap: Pollfish.ui.loadQuestionOrThankScreen.bind(Pollfish.ui),
  };

  $('body').attr('data-page', `question-${question.id}`);

  return (
    <Fragment>
      <div className="main-content__holder">
        <QuestionPrompt
          question={question}
          showText={!displaySamePage}
          showPrompt={!displaySamePage}
          showProgressBarQuestionIndex={!displaySamePage}
          questionIndex={questionIndex}
          showProgressBar
        />
        {renderQuestions.map((questionItem, index) => (
          <AnswersWrapper
            key={questionItem.refId || questionItem.id}
            question={questionItem}
            isDisplaySamePage={displaySamePage}
            questionIndex={questionIndex + index}
            showDivider={displaySamePage && index < renderQuestions.length - 1}
          />
        ))}
      </div>
      <SubmitButton {...submitBtnProps} />
    </Fragment>
  );
}

Question.propTypes = {
  question: PropTypes.object,
};
